import {IHttpService} from "angular";
import {AdviceTypes} from "../place-order-wizard/models/AdviceTypes";

export class OrderAdviceService {

    public static id = "orderAdviceService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async get(portfolioId: number): Promise<AdviceTypes> {
        const url = `/tradefloor/api/advice/${portfolioId}`;
        const response = await this.$http.get<AdviceTypes>(url);
        return response.data!;
    }
}